var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.334 6.66602C19.7005 6.66622 20 6.96644 20 7.33301V16.667C19.9999 17.0335 19.7004 17.3338 19.334 17.334H4.66602C4.29938 17.334 3.99913 17.0336 3.99902 16.667V7.33301C3.99902 6.96631 4.29932 6.66602 4.66602 6.66602H19.334ZM18.5273 8.25684C18.3013 7.96621 17.8824 7.91364 17.5918 8.13965L12 12.4883L6.4082 8.13965L6.33887 8.09277C6.05415 7.92363 5.68126 7.98862 5.47266 8.25684C5.24662 8.54747 5.29926 8.96631 5.58984 9.19238L11.5908 13.8594L11.665 13.9102C11.8973 14.045 12.1925 14.0279 12.4092 13.8594L18.4102 9.19238L18.4727 9.13672C18.7068 8.90253 18.7357 8.5251 18.5273 8.25684Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.6680a548f4ff85de28ef65dbbc0c2dc4.svg";
export { ForwardRef as ReactComponent };